function checkUrl() {
  $(".outermainsale").click(function () {
    navigator.clipboard.writeText(discountCode);
    $(".notify-copy").toggleClass("active-copy");
    $("#notifyType").toggleClass("success-copy");
    setTimeout(function () {
      $(".notify-copy").removeClass("active-copy");
      $("#notifyType").removeClass("success-copy");
    }, 2000);
  });
  var url = new URL(location.href);
  var d = url.searchParams.get("discount");
  // if(location.href.includes("early-black-friday-sunglasses-35")){
  //   showTimer35();
  //   return;
  // }
  if (d == "tk") {
    discountCode = "TIKTOK50";
    discountText = "50% OFF";
  } else if (d == "fb") {
    discountCode = "FB30";
    discountText = "30% OFF";
  } else if (d == "tk60") {
    discountCode = "TIKTOK60";
    discountText = "60% OFF";
  } else if (d == "fb60") {
    discountCode = "FB60";
    discountText = "60% OFF";
  } else if (d == "tk50") {
    discountCode = "TIKTOK50";
    discountText = "50% OFF";
  } else if (d == "fb40") {
    discountCode = "FB40";
    discountText = "40% OFF";
  } else if (d == "fb50") {
    discountCode = "FB50";
    discountText = "50% OFF";
  } else if (d == "fb25") {
    discountCode = "FB25";
    discountText = "25% OFF";
  } else if (d == "fb55") {
    discountCode = "FB55";
    discountText = "55% OFF";
  } else if (d == "fb45") {
    discountCode = "FB45";
    discountText = "45% OFF";
  } else if (d == "tk30") {
    discountCode = "TIKTOK30";
    discountText = "30% OFF";
  } else if (d == "tk40") {
    discountCode = "TIKTOK40";
    discountText = "40% OFF";
  } else if (d == "SNAP50") {
    discountCode = "SNAP50";
    discountText = "50% OFF";
  } else if (d == "SNAP40") {
    discountCode = "SNAP40";
    discountText = "40% OFF";
  }
 console.debug("code1: "+discountCode)
  if (discountCode != "") {
    showTimer(discountCode, discountText);
    localStorage.setItem("timerDate", new Date().getTime() +24*60* 60 * 1000);
    localStorage.setItem("discountCode", discountCode);
    localStorage.setItem("discountText", discountText);
    console.debug("code2: "+discountCode)
  } else {
    //showTimer35();
     
    CheckTimerSave();
  }
}
function showTimer35() {
  discountCode = "BFCM50"
  document.querySelector(".outermainsale").classList.remove("di-none"); 
  document.querySelector("#cart-icon-bubblee").classList.remove("onlysmalldevices");
  document.querySelector(".topacc").classList.add("di-none");
  document.querySelector(".outermainsale").classList.add("neon");
  document
    .querySelector("#shopify-section-sections--16150285516969__header")
    .classList.add("header-sticky-timer");
  document.querySelector(".timer-text-1").innerText = "Only";
  document.querySelector(".timer-text-2").innerText =
    "Left | Use Code: BFCM50";
  
}
function showTimer(discountCode, discountText) {
  document.querySelector(".outermainsale").classList.remove("di-none"); 
  document.querySelector("#cart-icon-bubblee").classList.remove("onlysmalldevices");
  document.querySelector(".topacc").classList.add("di-none");
  
  document
    .querySelector("#shopify-section-sections--16150285516969__header")
    .classList.add("header-sticky-timer");
  document.querySelector(".timer-text-1").innerText = "Get " + discountText;
  document.querySelector(".timer-text-2").innerText =
    "Use Code: " + discountCode;
}
function CheckTimerSave() {
  try {
    var currentTime = new Date().getTime();
    var savedTime = localStorage.getItem("timerDate");
    var SavedDiscountCode = localStorage.getItem("discountCode");
    var SavedDiscountText = localStorage.getItem("discountText");
   
    if (savedTime != null) {
      var EndDate = new Date(parseInt(savedTime)).getTime();
      if (currentTime < EndDate) {
        isSavedTimer = true;
        showTimer(SavedDiscountCode, SavedDiscountText);
      }
    }
  } catch (error) {}
}
var isSavedTimer = false;
var discountCode = "";
var discountText = "";
function addZero(time) {
  if ((time + "").length == 1) {
    time = "0" + time;
  }
  return time;
}
function autoSlideRebuy() {
  setInterval(function () {
    if ($("body").hasClass("rebuy-modal-visible")) {
      $(
        ".rebuy-cart__flyout-body #rebuy-widget-50768 .flickity-prev-next-button.next"
      ).click();
    }
  }, 3000);
}
function preventClick(event) {
  event.preventDefault();
}
function timerSetup() {
  checkUrl();
  if (discountCode == "" && !isSavedTimer) return;
  $(".timmer-wrap").removeClass("timer-d-none");
  var datedata = new Date();
  var givendate = datedata != false ? new Date(datedata) : new Date();
  givendate.setDate(givendate.getDate() + 1);
  var day = givendate.getUTCDate();
  var month = givendate.getUTCMonth() + 1;
  var year = givendate.getUTCFullYear();
  var monthnew = datedata.toLocaleString("default", { month: "short" });
  var result = "Jul 10, 2030";
  // var result = monthnew + " " + day + ", " + year;
  var second = 1000,
    minute = second * 60,
    hour = minute * 60,
    day = hour * 24;
  var countDown = new Date(result).getTime(),
    x = setInterval(function () {
      var now = new Date().getTime(),
        distance = countDown - now,
        hr = addZero(Math.floor((distance % day) / hour)),
        min = addZero(Math.floor((distance % hour) / minute)),
        sec = addZero(Math.floor((distance % minute) / second));
      document.querySelector(".custom-sale-timer .t-hr").innerText = hr;
      document.querySelector(".custom-sale-timer .t-min").innerText = min;
      document.querySelector(".custom-sale-timer .t-sec").innerText = sec;
      // var discountTimerFull =
      //   discountText + " " + hr + ":" + min + ":" + sec + " HRS LEFT";
      // document.querySelector(".di-text").innerText = discountTimerFull;
    }, second);
}
function newTimer() {
  checkUrl();
  var deadline = "December 7 2030 00:00:00 GMT+0200";
  initializeClock("countdown", deadline);
}
function getTimeRemaining(endtime) {
  var t = Date.parse(endtime) - Date.parse(new Date());
  var seconds = Math.floor((t / 1000) % 60);
  var minutes = Math.floor((t / 1000 / 60) % 60);
  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
  var days = Math.floor(t / (1000 * 60 * 60 * 24));
  return {
    total: t,
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds,
  };
}
function updateClock() {
  var t = getTimeRemaining(endtime);

  if (t.total <= 0) {
    clearInterval(timeinterval);

    var newTime = Date.parse(endtime);
    var nowTime = Date.parse(new Date());

    while (newTime <= nowTime) {
      newTime = newTime + 1 * 24 * 60 * 60 * 1000; // add 24hours
    }

    var deadline = new Date(newTime);
    initializeClock("countdown", deadline);
  } else {
    var discountTimerFull =
      discountText +
      " | " +
      addZero(t.hours) +
      ":" +
      addZero(t.minutes) +
      ":" +
      addZero(t.seconds) +
      " HRS LEFT";
    document.querySelector(".di-text").innerText = discountTimerFull;
  }
}
function initializeClock(id, endtime) {
  updateClock();
  var timeinterval = setInterval(updateClock, 2000);
}

function riseUp() {
  //add to cart
  // $(
  //   ".section-template--16164946346153__1d2ed460-4b0f-4c87-b4fa-df9315b815f7-padding .quick-add__submit>span:nth-child(1),.section-template--16164946346153__08862aa5-a698-42d8-a7cf-281658102ca4-padding .quick-add__submit>span:nth-child(1)"
  // ).text("PRE-ORDER NOW!");
  $("a[href='#add-to-cart']").click(function () {
    $(".product-form__buttons button").click();
  });
  //collection slider
  $(
    ".section-template--16164946346153__08862aa5-a698-42d8-a7cf-281658102ca4-padding .slider-button--next"
  ).click();
  setTimeout(function () {
    $(
      ".section-template--16164946346153__08862aa5-a698-42d8-a7cf-281658102ca4-padding .slider-button--next"
    ).click();
  }, 500);
  //banner visibility
  if (
    location.href.includes("products/rise-up-black-red") ||
    location.href.includes("products/rise-up-clear-silver")
  ) {
    $("#block-7b6fbef1-ca0c-4655-86d9-292eff094a1e").addClass("di-block");
    $("#block-bb4b348c-0842-4403-a48e-46eefd20b4de").html("");
  }
}
function updatePrescriptionPrice() {
  $(
    ".property-key-prescription-total-price .rebuy-cart__flyout-item-remove"
  ).click(function () {
    removeProducts();
  });
  var price = $(
    ".property-key-prescription-total-price>.rebuy-cart__flyout-item-property-value"
  ).text();
  if (price != "") {
    $(".property-key-prescription-type  .rebuy-money>span:nth-child(2)").text(
      "$" + price
    );
  }
}
function prescriptionSetup() {
  document.addEventListener("rebuy:cart.change", (event) => {
    updatePrescriptionPrice();
  });
  document.addEventListener("rebuy:smartcart.show", (event) => {
    updatePrescriptionPrice();
  });
}
function varentsToRemove(items) {
  let updates = {};
  items.forEach((item) => {
    if (
      item.properties["type"] != null ||
      item.properties["Group ID"] != null
    ) {
      updates[item.variant_id] = 0;
    }
  });
  return updates;
}
function removeProducts() {
  $.ajax({
    type: "GET",
    url: "/cart.js",
    cache: false,
    dataType: "json",
    success: function (cart) {
      // remove all products from cart
      jQuery.post(
        window.Shopify.routes.root + "cart/update.js",
        {
          updates: varentsToRemove(cart.items),
        },
        function (result) {}
      );
    },
  });
}
$(document).ready(function () {
  try {
    riseUp();
    timerSetup();
  } catch (e) {}

  // add isInViewport function
  $.fn.isInViewport = function () {
    try {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    } catch (e) {}
    return false;
  };
  autoSlideRebuy();

  $(".questiontab-a").click(function () {
    $(".questiontab-a").removeClass("active-a");
    $(this).addClass("active-a");
    var tagid = $(this).data("id");
    $(".question.legal-tab ").removeClass("tab-active");
    $("#" + tagid).addClass("tab-active");
  });

  $(".footer-block--menu .footer-block__heading").click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).next().slideUp();
    } else {
      $(".footer-block--menu .footer-block__heading").removeClass("open");
      $(".footer-block--menu .footer-block__details-content").slideUp();
      $(this).addClass("open");
      $(this).next().slideDown();
    }
  });
  $(".dropicon").click(function () {
    if ($(this).hasClass("menuopen")) {
      $(this).removeClass("menuopen");
      $(this).next().slideUp();
    } else {
      $(".dropicon").removeClass("menuopen");
      $(".megamenu-dropdown .mega-dropdown").slideUp();
      $(this).addClass("menuopen");
      $(this).next().slideDown();
    }
  });

  $(".modal-prescription .header-prescription .close").click(function () {
    $(".prescription-step-popup").hide();
    $("body").removeClass("overflowHidden");
    $('[data-step="1"]').addClass("active-step");
    $('[data-step="1"]').removeClass("done-step");
    $(".slide-page-dots li").removeClass("done-step active-step");
    $(".slide-page-dots li").eq(0).addClass("active-step");
    $(".step-wrapper").removeClass("done-step active-step");
    $(".step-wrapper").eq(0).addClass("active-step");
    $(".prev-arrow,.prev-button button").addClass("d-none");
  });
  $(".accordian-header").click(function () {
    if ($(this).hasClass("open")) {
      $(this).removeClass("open");
      $(this).next().slideUp();
    } else {
      $(".box-accordian .accordian-header").removeClass("open");
      $(".box-accordian .level-box").slideUp();
      $(this).addClass("open");
      $(this).next().slideDown();
    }
  });
  $(".product-main").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: ".product-thumb",
    responsive: [
      {
        breakpoint: 750,
        settings: {
          dots: true,
        },
      },
    ],
  });
  $(".product-thumb").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".product-main",
    dots: false,
    vertical: true,
    centerMode: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          vertical: false,
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".shapes-list ul").slick({
    slidesToShow: 12,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 9,
        },
      },
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 8,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        },
      },
    ],
  });
  $(".testimonial-slider-nav").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          arrows: true,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".product-carousel").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          arrows: true,
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".customer-reviews-slider").slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".product-variants").slick({
    infinite: true,
    slidesToShow: 3,
    centerMode: false,
    slidesToScroll: 3,
  });
  prescriptionSetup();
});
function debounce(func, wait = 100) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(this, args);
    }, wait);
  };
}
function switchCase() {
  $(".product-case").after($(".also-available"));
  $(".also-available").addClass("d-block");
}
function playvideos() {
  $(".video-desktop,.video-mobile").each(function (i, item) {
    item.play();
  });
}
$(window).on("resize scroll", function () {
  debounce(playvideos(), 2000);
});
if ($(".custom-add-to-cart .cart-price").length > 0) {
  $(".custom-add-to-cart,#add-product-to-cart").click(function () {
    $(".product-form__buttons button").click();
  });
  $(".custom-add-to-cart .cart-price")
    .first()
    .text(
      $(".price__container>.price__regular .price-item--regular")
        .first()
        .text()
        .trim()
    );
}
switchCase();
